// historySlice.js
import { createSlice } from '@reduxjs/toolkit';
import { RECEIVE_TRANSACTION_UPDATE } from '../Helper/webSocketActions';

const historySlice = createSlice({
  name: 'history',
  initialState: {
    isCollapsed: false,
    unreadCount: 0
  },
  reducers: {
    toggleHistory: state => {
      state.isCollapsed = !state.isCollapsed;
      if (!state.isCollapsed) {
        state.unreadCount = 0; // Reset unread count when opening the drawer
      }
    },
    incrementUnreadCount: state => {
      if (state.isCollapsed) {
        state.unreadCount += 1;
      }
    },
    resetUnreadCount: state => {
      state.unreadCount = 0;
    }
  },
  extraReducers: builder => {
    builder.addCase(RECEIVE_TRANSACTION_UPDATE, (state, action) => {
      if (!state.isCollapsed) {
        state.unreadCount += 1;
      }
    });
  }
});

export const { toggleHistory, incrementUnreadCount, resetUnreadCount } =
  historySlice.actions;
export default historySlice.reducer;
